import React, { useState } from "react";
import "./PaginaInicio.css";
import "./HomeworkModule.css";
import Cabecera from "../Others/Cabecera";
import BarraSuperior from "../Others/BarraSuperior";
import BarraInferior from "../Others/BarraInferior";
import PiePagina from "../Others/PiePagina";
import NavigationIcon from "../Others/NavigationIcon";
import { useData } from "./DataContext";
import AssignHomework from "./AsignarTareas";
import TeacherGradeHomework from "./TeacherGradeHomework";
import CaliciacionTeacher from "./CaliciacionTeacher";

const TeacherHomework = () => {
  const { dataClase } = useData();
  const [vista, setVista] = useState("asignar");

  return (
    <div className="contenedor-pagina">
      <Cabecera
        contenidosuperior={
          <BarraSuperior texto_cabecera={dataClase?.nombre_clase || "Ejercicios"} />
        }
        contenidoInferior={<BarraInferior />}
      />

      <main className="homework-module">
        <section className="homework-panel" aria-labelledby="teacher-homework-title">
          <header className="homework-hero">
            <div>
              <span className="homework-eyebrow">Gestión académica</span>
              <h1 id="teacher-homework-title">Ejercicios</h1>
              <p>
                Asigna actividades, revisa las entregas y consulta el avance
                general del grupo.
              </p>
            </div>
            <div className="homework-summary">
              <strong>3</strong>
              <span>herramientas disponibles</span>
            </div>
          </header>

          <nav className="homework-tabs" aria-label="Herramientas de ejercicios">
            <button
              type="button"
              className={"homework-tab " + (vista === "asignar" ? "is-active" : "")}
              aria-pressed={vista === "asignar"}
              onClick={() => setVista("asignar")}
            >
              <NavigationIcon name="tasks" size={18} />
              Asignar tarea
            </button>
            <button
              type="button"
              className={"homework-tab " + (vista === "calificar" ? "is-active" : "")}
              aria-pressed={vista === "calificar"}
              onClick={() => setVista("calificar")}
            >
              <NavigationIcon name="deliverables" size={18} />
              Calificar tareas
            </button>
            <button
              type="button"
              className={"homework-tab " + (vista === "calificacion" ? "is-active" : "")}
              aria-pressed={vista === "calificacion"}
              onClick={() => setVista("calificacion")}
            >
              <NavigationIcon name="diagnostic" size={18} />
              Calificaciones
            </button>
          </nav>

          <div className="homework-body">
            <div className="homework-workspace">
              {vista === "asignar" && <AssignHomework />}
              {vista === "calificar" && <TeacherGradeHomework />}
              {vista === "calificacion" && <CaliciacionTeacher />}
            </div>
          </div>
        </section>
      </main>

      <PiePagina imagenSrc={require("../Assets/piepagina.jpg")} />
      <footer>Grupo Derecho & Progreso &copy; 2024</footer>
    </div>
  );
};

export default TeacherHomework;
